export const sortByName = (a: any, b: any): number => {
  if (a.name?.toLowerCase() > b.name?.toLowerCase()) return 1;
  if (b.name?.toLowerCase() > a.name?.toLowerCase()) return -1;
  return 0;
};
